<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Profil Joueur</h2>
                        </div>

                        <!-- <div class="alert alert-warning alert-dismissible fade show rounded-xl"
                            :class="{ 'd-none': currentUser.phone_number }" role="alert">
                            Merci de renseigner votre numéro téléphone <a href="/my/profile"><b>ici</b></a> pour valider
                            votre compte.
                        </div>
                        <div class="alert alert-warning alert-dismissible fade show"
                            :class="{ 'd-none': currentUser.is_verified || !currentUser.phone_number }" role="alert">
                            Merci de vérifier votre numéro téléphone <a href="/otp-verification"><b>ici</b></a> pour
                            valider votre compte.
                        </div> -->

                        <!-- Profile Settings Form -->
                        <form @submit.prevent="editProfile" class="pb-5">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Nom Joueur</label>
                                        <input type="text" class="form-control" v-model="user.full_name" required :disabled="true"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Date de Naissance</label>
                                        <input type="text" class="form-control date" v-model="player.date_of_birth"/>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="!user.delegation || user.delegation === ''">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Délégation</label>
                                        <v-select :options="delegations" v-model="user.delegation" label="option"
                                            :reduce="option => option" class="custom-vs form-control input">
                                            <template #option="{ option }">
                                                <span><b>{{ option.split(', ')[0] }}</b>, {{ option.split(', ')[1] }}</span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Poste(s) Préférée(s)</label>
                                        <br/>
                                        <div class="custom-control custom-radio custom-control-inline mt-1 ml-2">
                                            <input type="checkbox" id="position1" v-model="player.position" value="goalkeeper" name="position" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="position1">Gardien</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="checkbox" id="position2" v-model="player.position" value="defender" name="position" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="position2">Défenseur</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="checkbox" id="position3" v-model="player.position" value="midfielder" name="position" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="position3">Milieu</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="checkbox" id="position4" v-model="player.position" value="forward" name="position" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="position4">Attaquant</label>
                                        </div>
                                    </div>
                                    <div class="form-group card-label mb-3">
                                        <label>Pied Fort</label>
                                        <br/>
                                        <div class="custom-control custom-radio custom-control-inline mt-1 ml-2">
                                            <input type="radio" id="dominantFoot1" v-model="player.dominant_foot" value="left" name="dominantFoot" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="dominantFoot1">Gauche</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="dominantFoot2" v-model="player.dominant_foot" value="right" name="dominantFoot" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="dominantFoot2">Droit</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="dominantFoot3" v-model="player.dominant_foot" value="both" name="dominantFoot" class="custom-control-input">
                                            <label class="custom-control-label custom-control-primary" for="dominantFoot3">Les deux</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Numéro Préféré</label>
                                        <!-- <select class="form-control custom-select" v-model="player.preferred_number">
                                            <option value="0">0</option>
                                            <option v-for="number in 99" :value="number">{{ number }}</option>
                                        </select> -->
                                        <div class="d-flex justify-content-between align-items-center">
                                            <a href="javascript:void(0)" @click="decrementPreferredNumber()"><span class="material-symbols-outlined h1">arrow_back_ios_new</span></a>
                                            <div class="position-relative">
                                                <!-- <span class="material-symbols-outlined" style="font-size: 7rem;font-weight: 200;">apparel</span> -->
                                                <svg xmlns="http://www.w3.org/2000/svg" height="112px"
                                                    viewBox="0 -960 960 960" width="112px" fill="#505050">
                                                    <path
                                                        d="m284.62-610.54-82.24 45.77q-10.92 6.46-22.73 3.84-11.8-2.63-16.73-14.3l-44.38-75.92q-6.46-11.7-3.35-20.93 3.12-9.23 13.85-15.65L317.77-800h45.54q12.61 0 19.84 7.02t7.23 19.29v5.77q0 38 25.93 63.92 25.92 25.92 63.92 25.92T544.42-704q26.2-25.92 26.2-63.92v-5.77q0-12.27 7.01-19.29 7.02-7.02 19.29-7.02h45.54l189.45 112.27q10.78 6.42 13.4 15.65 2.61 9.23-3.62 20.93l-44.82 75.64q-5.02 11.74-18.25 14.97-13.24 3.23-22.7-3l-82-48.23v421.23q0 12.92-8.92 21.73T643.41-160H314.9q-12.67 0-21.48-8.81-8.8-8.81-8.8-21.73v-420Zm30.76-52.77v472.54h327.77v-472.54l128.77 71.62 41.93-72.62L636.08-769h-34.16q.46 50.92-34.8 86.31-35.27 35.38-86.89 35.38-51.61 0-86.61-35.38-35-35.39-35.31-86.31h-33.39L146.38-664.31l41.93 72.62 127.07-71.62ZM480.23-480Z" />
                                                </svg>
                                                <span class="position-absolute h3 d-block w-100 text-center" style="top: 42%;">{{ player.preferred_number }}</span>
                                                <input type="number" min="0" max="99" v-model="player.preferred_number" class="d-none"/>
                                            </div>
                                            <a href="javascript:void(0)" @click="incrementPreferredNumber()"><span class="material-symbols-outlined h1">arrow_forward_ios</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Taille (cm)</label>
                                        <input type="number" min="100" max="250" class="form-control" v-model="player.height_cm"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Poids (kg)</label>
                                        <input type="number" min="30" class="form-control" v-model="player.weight_kg"/>
                                    </div>
                                </div>
                            </div>
                            <div class="submit-section">
                                <button type="submit" class="btn btn-primary btn-rounded px-4">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Modifier</label>
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style>
td.ui-datepicker-today {
    font-weight: 600;
}
select.ui-datepicker-month {
    margin-right: 3px;
}
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import { del } from "vue";

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        joiningDate() {
            return (moment(this.$store.getters.currentUser.created_at).format('LL')).toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase())
        }
    },
    data() {
        return {
            delegations: [],
            player: {
                preferred_number: 0,
                position: []
            },
            user: {},
        }
    },
    mounted() {
        this.getPlayerProfile()
        this.getDelegations()
        this.user = this.currentUser
        const vm = this
        $(document).ready(function() {
            $('.date').datepicker({
                dateFormat: 'yy-mm-dd',
                maxDate: "-10Y",
                changeMonth: true,       // Enable year selection
                changeYear: true,        // Enable year selection
                yearRange: "1900:2100",  // Year range (1900 to 2100)
                onSelect: (dateText) => {
                    vm.player.date_of_birth = dateText;
                }
            });
        })
    },
    methods: {
        normalizePositions(position) {
            if (Array.isArray(position)) {
                return position.filter(Boolean)
            }

            if (typeof position === 'string') {
                return position
                    .split(',')
                    .map(item => item.trim())
                    .filter(Boolean)
            }

            return []
        },
        getPlayerProfile() {
            api.get('/private/players/me')
                .then(response => {
                    const result = response.data
                    this.player = (result) ? result : {}
                    this.player.position = this.normalizePositions(this.player.position)
                    this.player.name = (!this.player || !this.player.name) ? this.user.full_name : this.player.name
                })
        },
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async editProfile() {
            if (!this.user.delegation || this.user.delegation === '') {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'warning',
                    icon_color: 'text-warning',
                    title: 'Informations manquantes',
                    detail: 'Merci de sélectionner votre délégation.'
                })
                return
            } else {
                $('.submit-section button').attr('disabled', 'disabled')
                $('.submit-section button span').removeClass('d-none')
                this.player.preferred_number = (!this.player || !this.player.preferred_number) ? null : parseInt(this.player.preferred_number)
                let player = {...this.player}
                player.position = this.normalizePositions(this.player.position).join(",")
                player.delegation = this.user.delegation
                player.name = (!player.name) ? this.user.full_name : player.name
                setTimeout(() => {
                    api.patch('/private/players/me', player)
                        .then(response => {
                            this.$store.dispatch('modal/triggerModal', {
                                icon: 'check_circle',
                                icon_color: 'text-success',
                                title: 'Succès',
                                detail: 'Votre profil joueur a été mis à jour avec succès.'
                            })
                        })
                        .catch(error => {
                            this.$store.dispatch('modal/triggerModal', {
                                icon: 'error',
                                icon_color: 'text-danger',
                                title: 'Erreur',
                                detail: 'Une erreur s\'est produite lors de la mise à jour du profil.'
                            })
                        })
                        .finally(() => {
                            $('.submit-section button').removeAttr('disabled')
                            $('.submit-section button span').addClass('d-none')
                            this.getPlayerProfile()
                        })
                }, 2000);
            }
        },
        decrementPreferredNumber() {
            this.player.preferred_number = (this.player.preferred_number > 0) ? this.player.preferred_number-1 : this.player.preferred_number
        },
        incrementPreferredNumber() {
            this.player.preferred_number = (this.player.preferred_number < 99) ? this.player.preferred_number+1 : this.player.preferred_number
        }
    },
};
</script>
